module.exports = __webpack_public_path__ + "static/media/bell-white.15ad74c4.svg";